import React from 'react'
import useStyles from './styles'
import Show, { Chip } from 'components/root/Show/Show'
import { Show as ShowData } from 'data/Show'
import { formatTime } from 'utils/date'

interface FeaturedShowProps {
    show: ShowData
    onClick: (ShowData) => void
}

const FeaturedShow: React.FC<FeaturedShowProps> = ({ show, onClick }) => {
    const classes = useStyles()

    return (
        <div onClick={() => onClick(show)} className={classes.box}>
            <Show show={show} featured />
            <div className={classes.info}>
                <h1>{show.title}</h1>
                <h3>{show.description}</h3>
                <Chip>{formatTime(show.startTime)}</Chip>
                <p>Enter The Event</p>
            </div>
        </div>
    )
}

export default React.memo(FeaturedShow)
